<div class="card card-transaction">
  <div class="card-header d-flex justify-content-between align-items-start">
    <h4 class="card-title">{{ "MENU.MANAGE_SUPPORT_REQUEST" | translate }}</h4>
    <a *ngIf="ticket_list.length > 0" routerLink="/dashboard/ticket/all-ticket-list">{{ "VIEW_ALL_FEMALE" | translate }}</a>
  </div>
  <div class="card-body" *ngIf="ticket_list && ticket_list.length > 0; else noTicket">
    <div class="mb-1" *ngFor="let item of ticket_list">
      <div class="ticket-item" [ngbTooltip]="item.enabled_label" placement="left">
        <div class="bg-{{ item.last_step.status === 0 ? 'secondary' : item.last_step.status === 1 ? 'warning' : 'success' }}"></div>
        <div>
          <a class="font-weight-medium text-break-line-1" [routerLink]="'/dashboard/ticket/all-ticket-list'" [queryParams]="{ id: item.id }">{{ item.title }}</a>
          <small>{{ "FROM_PERSON" | translate }} {{ item.user.complete_name }} {{ "THE_MASCULIN" | translate }} {{ _utilsService.formatDate(item.insert_date) }}</small>
        </div>
      </div>
    </div>
  </div>
  <ng-template #noTicket>
    <div class="card-body" *ngIf="!ticket_list || ticket_list.length < 1">
      {{ "NOT_ONE_SUPPORT_REQUEST" | translate }}
    </div>
  </ng-template>
</div>
